import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import MDBox from "../../../../../components/MDBox";
import FormField from "../../../../../components/FormField";
import MDTypography from "../../../../../components/MDTypography";

const AddTimeToAllForm = ({ formData, players, setFieldValue }) => {
    const { formField, values, errors, touched } = formData;
    const { hours, is_free, is_late_night } = formField;
    const {
        hours: hoursV,
        is_free: isFreeV,
        is_late_night: isLateNightV,
    } = values;

    const { players: selectedPlayers = [] } = values;

    const handlePlayerSelection = (playerId) => {
        const updatedPlayers = selectedPlayers.includes(playerId)
            ? selectedPlayers.filter((id) => id !== playerId)
            : [...selectedPlayers, playerId];

        setFieldValue("players", updatedPlayers); // Update `values.players` using Formik
    };

    // Split players into two columns
    const midIndex = Math.ceil(players.length / 2);
    const column1 = players.slice(0, midIndex);
    const column2 = players.slice(midIndex);


    return (
        <MDBox>
            <Grid container spacing={3}>
                {/* Hours Field */}
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={hours.type}
                        label={hours.label}
                        name={hours.name}
                        value={hoursV}
                        error={errors.hours && touched.hours}
                        success={hoursV && hoursV.length > 0 && !errors.hours}
                    />
                </Grid>

                {/* Is Free Field */}
                <Grid item xs={12} sm={6}>
                    <FormField
                        type={is_free.type}
                        label={is_free.label}
                        name={is_free.name}
                        value={isFreeV}
                    />
                </Grid>

                {/* Is Late Night Field */}
                <Grid item xs={12} sm={6}>
                    <FormField
                        type={is_late_night.type}
                        label={is_late_night.label}
                        name={is_late_night.name}
                        value={isLateNightV}
                    />
                </Grid>

                {/* Players Checkbox List */}
                <Grid item xs={12}>
                    <MDTypography variant="h6" fontWeight="medium" gutterBottom>
                        Select Players
                    </MDTypography>
                    <Grid container spacing={2}>
                        {/* First Column */}
                        <Grid item xs={6}>
                            {column1.map((player) => (
                                <FormControlLabel
                                    key={player.id}
                                    control={
                                        <Checkbox
                                            checked={selectedPlayers.includes(player.id)}
                                            onChange={() => handlePlayerSelection(player.id)}
                                        />
                                    }
                                    label={`${player.member.name}`}
                                />
                            ))}
                        </Grid>

                        {/* Second Column */}
                        <Grid item xs={6}>
                            {column2.map((player) => (
                                <FormControlLabel
                                    key={player.id}
                                    control={
                                        <Checkbox
                                            checked={selectedPlayers.includes(player.id)}
                                            onChange={() => handlePlayerSelection(player.id)}
                                        />
                                    }
                                    label={`${player.member.name}`}
                                />
                            ))}
                        </Grid>
                    </Grid>
                </Grid>
                </Grid>
        </MDBox>
    );
}

export default AddTimeToAllForm;
